import type { NPMapOptions } from "@npmap/base";
import type { FeatureCollection } from "geojson";


const popupBody = `
    {{#htmlElement "div" style="max-height: 200px; overflow-y: auto;"}}            
    {{table (hash
      [Event Type]=(json "core_details.event_type")
      Direction=(json "core_details.direction")
      Impact=vehicle_impact
      Details=(json "core_details.description")
      [Start Date]=(coalesce start_date 'Unspecified')
      [End Date]=(coalesce end_date 'Unspecified')
    ) ul=true}}
    {{/htmlElement}}`

export function style(geojsonData: FeatureCollection): NPMapOptions['style'] {
    const style: NPMapOptions['style'] = {
        'version': 'NPMap5',
        'basemap': ['mapbox://styles/atlas-user/ck58pyquo009v01p99xebegr9'],
        'sources': {
            'alerts': {
                type: 'geojson',
                data: geojsonData
            }
        },
        'layers': [
            {
                id: 'RoadAlerts',
                type: 'line',
                source: 'alerts',
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                paint: {
                    'line-color': '#720f04',
                    'line-opacity': 0,
                    'line-width': 5
                },
                popup: {
                    'header': '{{coalesce (json "core_details.name") (join " " (json "core_details.road_names.[0]")  (json "core_details.direction")) }}',
                    'body': popupBody,
                    'options': {} // This should be optional, but there's a bug in NPMap5, this should be fixed in 5.0.6
                }
            }
        ]
    };
    return style;
};